import * as types from './actions';
import APIUtil from '../config/APIUtil';
import UrlConstants from '../config/UrlConstants';
import * as code from '../config/Constants';


/**
 * @desc Transactions - get All
 */
export function getBuyerTransactionsAction() {  
   
    let url = UrlConstants.buyerTransactionsList;
    return function (dispatch){
      return APIUtil.getMethod(url, true).then(response => {
          if(response.status == code.OK) {
              dispatch( {
                  type: types.GET_ALL_BUYER_TRANSACTIONS,
                  buyerTransactions: response.data
              });
          }
          else {
              dispatch( {
                  type: types.GET_ALL_BUYER_TRANSACTIONS,
                  buyerTransactions: []
              });
          }
      });
    }  
}
/**
 * @desc get buyer agent tasks of transaction
 * @param {*} transactionId 
 */
export function getBuyerTasksAction(transactionId) {

    let url = UrlConstants.buyerTasksUrl + transactionId;

    return function (dispatch){
      return APIUtil.getMethod(url, true).then(response => {
          
          if(response.status == code.OK) {
              dispatch( {
                  type: types.GET_ALL_BUYER_TASKS,
                  buyerTasks: response.data
              });
          }
          else {
              dispatch( {
                  type: types.GET_ALL_BUYER_TASKS,
                  buyerTasks: []
              });
          }
      });
    }  
}
